import styled from 'styled-components';
import { blueDark01 } from '../../../styles/colors';

export const EC3Rect = styled('span')`
    width: 15px;
    height: 8px;
    background-color: ${(props: { color: string }) => props.color};
    margin-right: 5px;
    color: ${blueDark01};
    display: inline-block;
`;
